<template>
  <main>
    <!-- Header -->
    <header class="header fixed up priority-4">
      <div class="flex width-10 align-items-center justify-content-between">
        <div class="f-center">
          <a class="c-pointer priority-3 mr-3" href="https://www.union.sk" target="_blank">
            <i class="icon icon--union priority-2"></i>
          </a>
        </div>

        <p class="font-price font-price-bigger">1/8</p>
      </div>
    </header>

    <!-- EID view -->
    <section class="wrapper align-items-center f-column min-win-height pb-10">
      <div class="eid-container">
        <!-- EID Alert -->
        <div class="snack-bar orange flex align-items-center">
          <i class="icon icon--info-white mr-2"></i>
          <p class="font-white">To successfully sign the application form, do not disconnect the card reader with the ID card until the signature process has been completed.</p>
        </div>

        <!-- Union info && spinner -->
        <div class="union-info-and-spinner width-10">
          <!-- Union info -->
          <div class="info-holder">
            <ul :class="{'visible': currentSlide === 1}" class="info-slide mb-children-2 font-gray font-medium">
              <li>Annual Bonus of €150 for Dental Care</li>
              <li>Annual Healthy Eyesight Benefits Package worth €150</li>
              <li>€100 Benefits Package for Infants</li>
            </ul>

            <ul :class="{'visible': currentSlide === 2}" class="info-slide mb-children-2 font-gray font-medium">
              <li>Contract Healthcare Providers in Every City</li>
              <li>Up to 50% Discount on Commercial Insurance</li>
              <li>Rewards for Preventive Care</li>
            </ul>

            <ul :class="{'visible': currentSlide === 3}" class="info-slide mb-children-2 font-gray font-medium">
              <li>Bonuses for Vaccination Beyond the Legal Minimum – up to 100%</li>
              <li>€70 Bonus for Food Intolerance Screening</li>
              <li>More Accessible Appointment Times for Diagnostic Tests</li>
            </ul>
          </div>

          <!-- Spinner -->
          <div class="spinner-holder">
            <div class="spinner"></div>
          </div>
        </div>

        <!-- Progress section -->
        <div class="progress-cards flex f-column justify-content-center width-10">
          <!-- Progress slider -->
          <div
            class="progress-slider flex f-column justify-content-center width-10"
            :style="{ transform: `translateX(-${sliderTranslateX}%)` }"
          >
            <!-- Progress bar -->
            <div class="progress-bar">
              <div
                class="progress-circle"
                v-for="item in 8"
                :key="item + 1"
                :class="{'success': item <= currentProgress}"
              ><strong>{{item}}.</strong></div>
            </div>

            <!-- Progress card -->
            <div class="progress-cards-holder">
              <!-- Card 1 -->
              <div class="progress-card" :class="{'success': currentProgress >= 1}">
                <h3 class="mb-1">Insert your eID card into the reader</h3>
                <p>Connect the card reader to your computer and insert your electronic ID card with a chip.</p>
              </div>

              <!-- Card 2 -->
              <div class="progress-card" :class="{'success': currentProgress >= 2}">
                <h3 class="mb-1">Enter Your BOK</h3>
                <p>BOK is the personal security code you have created for your eID card. It is used to confirm the cardholder's identity.</p>
              </div>

              <!-- Card 3 -->
              <div class="progress-card" :class="{'success': currentProgress >= 3}">
                <h3 class="mb-1">Launch the D.Signer App</h3>
                <div class="snack-bar orange mb-1">
                  <div class="font-white">A Window May Not Appear</div>
                </div>
                <p>If the window for launching the D.Signer application has appeared, press the “Run” button.</p>
              </div>

              <!-- Card 4 -->
              <div class="progress-card" :class="{'success': currentProgress >= 4}">
                <h3 class="mb-1">Sign the Application Form</h3>
                <p>In the D.Signer window, press the “Sign” button.</p>
              </div>

              <!-- Card 5 -->
              <div class="progress-card" :class="{'success': currentProgress >= 5}">
                <h3 class="mb-1">Select a Certificate</h3>
                <p>
    In the Certificate Selection window that appears, select the certificate (your eID card) that you will use to sign the application form.
    If the certificate does not load successfully, press the “Refresh” button (green arrow) at the bottom of the window.
  </p>
              </div>

              <!-- Card 6 -->
              <div class="progress-card" :class="{'success': currentProgress >= 6}">
                <h3 class="mb-1">Enter Your KEP PIN</h3>
                <p>Enter the 6-digit PIN code that you created for your eID card to complete the application signature.</p>
              </div>

              <!-- Card 7 -->
              <div class="progress-card" :class="{'success': currentProgress >= 7}">
                <h3 class="mb-1">Signature Confirmation,</h3>
                <p>In the D.Signer window that appears, press the “OK” button to verify your signature using your eID card.</p>
              </div>

              <!-- Card 8 -->
              <div class="progress-card" :class="{'success': currentProgress >= 8}">
                <h3 class="mb-1">All Done</h3>
                <p>
    We are redirecting you to the Union ZP Thank You page.
    We will inform you about the result of the electronic signature verification via e-mail.
  </p>
              </div>
            </div>
          </div>

          <!-- Progress shadow right -->
          <transition name="fade">
            <div v-if="currentProgress < 6" class="progress-shadow-right"></div>
          </transition>

          <!-- Arrows -->
          <transition name="fade">
            <button v-if="currentProgress > 1" class="slider-arrows arrow-left" @click="currentProgress = currentProgress - 1">
              <i class="mobile-arrow icon icon--arrow-right-mobile"></i>
            </button>
          </transition>
          <transition name="fade">
            <button v-if="currentProgress < 6" class="slider-arrows arrow-right" @click="currentProgress = currentProgress + 1">
              <i class="mobile-arrow icon icon--arrow-right-mobile"></i>
            </button>
          </transition>
        </div>
      </div>

      <!-- Transparent footer -->
      <TransparentFooter></TransparentFooter>
    </section>
  </main>
</template>

<script>
/* eslint-disable */
import TransparentFooter from '../components/Footer/TransparentFooter.vue';
import GA from '@/mixins/GA';

export default {
  name: 'EID',
  components: { TransparentFooter },
  mixins: [GA],
  props: {
    model: { type: Object, required: true },
    errors: { type: Array, required: true },
  },
  data: () => ({
    currentProgress: 1,
    currentSlide: 1,
    signedXmlData: null,
		configForTsDone: null,
		xmlTimeStamp: null,
		signedXmlWithEnvelopeAndTimeStampBase64: null,
		tsResponseB64: null,
  }),
  computed: {
    sliderTranslateX() {
      if (this.currentProgress === 1) return 0;
      if (this.currentProgress === 2) return 10;
      if (this.currentProgress === 3) return 23;
      if (this.currentProgress === 4) return 35;
      if (this.currentProgress === 5) return 47;
      return 53;
    },
  },
  methods: {
  	signNext(stepName) {
  		return {
  			onSuccess: (response) => {
  				if (stepName) this[stepName](response);
        },
        onError: (e) => {
  				console.log(e.code, 'ON ERROR E-CODE');
  				console.log(e.stack, 'ON ERROR E-STACK');

  				const logMessage = { message: `STEP: ${stepName} / CISLO PRIHLASKY: ${this.model.saveResponse.cislo} / CODE: ${e.code} / STACK: ${e.stack} / COMPLETE: ${e}` };
					this.$axios.post(`${process.env.VUE_APP_API_CONTEXT}/japi/IUzpApi/eidLogMessage`, [logMessage]);

					this.$router.push({ name: 'FailEID', query: this.$route.query });
				}
      }
    },
		async messageContainerFinish(response) {
			console.log("STEP: messageContainerFinish");
			const dataForSaveSigned = {
				xmlData: B64.encode(response),
				variableSymbol: this.model.saveResponse.cislo,
				leadUuid: this.model.leadUuid
			};

			try {
				await this.$axios.post(`${process.env.VUE_APP_API_CONTEXT}/japi/IUzpApi/saveSigned`, [dataForSaveSigned]);
				this.$router.push({ name: 'EIDSuccess', query: this.$route.query });
			} catch (e) {
				this.$router.push({ name: 'FailEID', query: this.$route.query });
			}
		},
		getMessageContainer() {
			console.log("STEP: getMessageContainer");
			ditec.dSigXadesExtenderJs.getMessageContainer().getMessageContainer(this.signNext('messageContainerFinish'));
		},
		addBase64Object() {
			console.log("STEP: addBase64Object");
			const id = "id1"; //uzp prihlaska
			const inBase64Object = this.signedXmlWithEnvelopeAndTimeStampBase64;
			ditec.dSigXadesExtenderJs.getMessageContainer().addBase64Object(
				id,
				"name", // nazov typu dokumentu - uzp prihlaska
				"description", //nazov prihlasky v plnom zneni
				"classAttr", // form
				true,
				"application/vnd.etsi.asic-e+zip",
				inBase64Object,
				this.signNext('getMessageContainer')
			);
    },
		messageContainerStart() {
			console.log("STEP: messageContainerStart");
			ditec.dSigXadesExtenderJs.getMessageContainer().initialize(
				this.model.saveResponse.cislo, //guid //
				"senderId", //uri fe apky
				"recipientId", //uri pa
				"messageType", //mime type signed xml
				"",
				"",
				"",
				this.signNext('addBase64Object')
			);
    },
    deploy2(response) {
			console.log("STEP: deploy2");
			ditec.dSigXadesExtenderJs.deploy(null, this.signNext('messageContainerStart', response));
    },
		timestampFinish(response) {
			console.log("STEP: timestampFinish");
			this.signedXmlWithEnvelopeAndTimeStampBase64 = response;
			this.deploy2();
    },
		getSignatureAndTimeStampWithASiCEnvelopeBase64() {
			console.log("STEP: getSignatureAndTimeStampWithASiCEnvelopeBase64");
			ditec.dSigXadesBpJs.getSignatureAndTimeStampWithASiCEnvelopeBase64(this.signNext('timestampFinish'));
		},
		createXAdESZepBpT(tsResponseB64) {
			console.log("STEP: createXAdESZepBpT");
			const tsCertB64 = ""; //moze byt prazdny
			ditec.dSigXadesBpJs.createXAdESZepBpT(
				tsResponseB64,
        tsCertB64,
        this.signNext('getSignatureAndTimeStampWithASiCEnvelopeBase64')
      );
    },
		async getTimestamp(tsRequestB64) {
			console.log("STEP: getTimestamp");

			this.xmlTimeStamp = tsRequestB64;

			if (!tsRequestB64) {
				await this.$router.push({ name: 'FailEID', query: this.$route.query });
				return;
			}

      try {
				const res = await this.$axios.post(`${process.env.VUE_APP_API_CONTEXT}/japi/IUzpApi/getTimestamp`, [{ tsRequestB64 }]);
        this.tsResponseB64 = res.data.timestamp;
        this.createXAdESZepBpT(this.tsResponseB64);
			} catch (e) {
				await this.$router.push({ name: 'FailEID', query: this.$route.query });
			}
		},
		getSignatureTimeStampRequestBase64(response) {
			console.log("STEP: getSignatureTimeStampRequestBase64");

  		this.configForTsDone = response;

			if (response !== 0 && response !== null) {
				this.$router.push({ name: 'FailEID', query: this.$route.query });
				return;
			}

			const reqPolicy = "1.3.6.1.4.1.23624.10.1.50.2.0";
			const digestAlgUri = ditec.dSigXadesBpJs.SHA256;

			ditec.dSigXadesBpJs.getSignatureTimeStampRequestBase64(
				reqPolicy,
				digestAlgUri,
				this.signNext('getTimestamp')
			);
    },
		timestampStart() {
			console.log("STEP: timestampStart");

			const configsZipBase64 = ditec.samples.configsZipBase64;
			ditec.dSigXadesBpJs.loadConfiguration(configsZipBase64, this.signNext('getSignatureTimeStampRequestBase64'));
    },
		signFinish(response) {
			console.log("STEP: signFinish");
  		this.signedXmlData = response;
      this.timestampStart();
    },
		getSignatureWithASiCEnvelopeBase64() {
			console.log("STEP: getSignatureWithASiCEnvelopeBase64");
			ditec.dSigXadesBpJs.getSignatureWithASiCEnvelopeBase64(this.signNext('signFinish'));
    },
  	sign() {
			console.log("STEP: sign");

			const signatureId = "signatureId"; // vygenerovat jeden guid - vlozit sem vygenerovany
			const digestAlgUri = ditec.dSigXadesBpJs.SHA256;
			const signaturePolicyIdentifier = "urn:oid:1.3.158.36061701.1.2.2"; //ostava

			ditec.dSigXadesBpJs.sign(
				signatureId,
        digestAlgUri,
        signaturePolicyIdentifier,
        this.signNext('getSignatureWithASiCEnvelopeBase64')
      );
    },
    startSigning() {
			console.log("STEP: start signing");

      const objectId = 'test.xml'; // uzp_prihlaska_vs.xml
      const objectDescription = 'prihlaska'; // uzp_prihlaska vs
      const objectFormatIdentifier = 'http://www.ditec.sk/objectFormatIdentifier'; // uri xsd schemy + verzia
      const xdcIdentifier = '428465'; // uri xsd schemy
      const xdcVersion = '1.01'; // verzia xml dokumentu
      const xsdReferenceURI = 'http://www.ditec.sk/xsdReference'; // uri xsd schemy + verzia
      const xslReferenceURI = 'http://www.ditec.sk/xslReference'; // uri na xslt + verzia
			const xslMediaDestinationTypeDescription = ditec.dSigXadesBpJs.XML_MEDIA_DESTINATION_TYPE_DESC_HTML; // eslint-disable-line
      const xslXSLTLanguage = ditec.dSigXadesBpJs.LANG_SK;
      const xslTargetEnvironment = ''; // kludne prazdny
      const xdcIncludeRefs = false; // false
      const xdcXMLData = B64.decode(this.model.saveResponse.xmlData);

      // const xdcXMLData = B64.decode(ditec.samples.xml1B64);
      const xdcUsedXSD = B64.decode(ditec.samples.xsd1B64);
      const xdcUsedXSLT = B64.decode(ditec.samples.xslttxt1B64);
      const xdcNamespaceURI = ditec.dSigXadesBpJs.XML_XDC_NAMESPACE_URI_V1_1;

			ditec.dSigXadesBpJs.addXmlObject(
				objectId, objectDescription, objectFormatIdentifier,
				xdcXMLData, xdcIdentifier, xdcVersion, xdcUsedXSD,
				xsdReferenceURI, xdcUsedXSLT, xslReferenceURI,
        xslMediaDestinationTypeDescription, xslXSLTLanguage,
        xslTargetEnvironment, xdcIncludeRefs, xdcNamespaceURI,
			  this.signNext('sign'),
      );
    },
    deploy() {
  		console.log("STEP: DEPLOY");
      this.currentProgress = 1;
      ditec.dSigXadesBpJs.deploy(null, this.signNext('startSigning'));
    },
  },
  mounted() {
  	this.deploy();
    setInterval(() => {
    	if (this.currentSlide === 3) this.currentSlide = 1;
      else this.currentSlide += 1;
    }, 6000);
    this.funnelStep('epodpis podpisovač');
  }
};
/* eslint-enable */
</script>

<style lang="scss" scoped>
  @import "~union_styles/scss/variables";
  @import "~union_styles/scss/helpers/mixins/position";
  @import "~union_styles/scss/helpers/mixins/flexbox";
  $color-primary: #5DB100;
  $spinner-size: 150px;
  $info-holder-size: 400px;
  $card-width: 300px;
  $cards-count: 8;
  $progress-circle-size: 50px;
  $card-margin-right: 10px;

  .slider-arrows {
    width: 62px;
    height: 62px;
    background-color: $color-primary;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    transform: translateY(calc(-50% + 40px));

    &.arrow-left {
      left: 20px;
      i { transform: rotate(180deg); }
    }

    &.arrow-right {
      right: 20px;
    }
  }

  .eid-container {
    max-width: 90vw;
    width: 70vw;

    @media (max-width: 1620px) { width: 80vw; }
    @media (max-width: 1420px) { width: 90vw; }
    @media (max-width: 1024px) { width: 90%; }

    .union-info-and-spinner {
      display: flex;
      padding: 80px 0;

      @media (max-width: 1620px) { padding: 40px 0; }

      .info-holder {
        width: $info-holder-size;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;

        ul {
          padding-left: 20px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: $info-holder-size;
          flex-shrink: 0;
          transition: all .4s ease;
          opacity: 0;

          &.visible {
            opacity: 1;
            transition-delay: .5s;
          }
        }
      }

      .spinner-holder {
        width: calc(100% - #{$info-holder-size});
        display: flex;
        align-items: center;
        justify-content: center;

        .spinner {
          width: $spinner-size;
          height: $spinner-size;
          border-top: 3px solid $color-primary;
          border-right: 3px solid transparent;
          border-radius: 50%;
          animation: rotation 1.2s linear infinite;
        }
      }
    }

    .progress-cards {
      width: 100%;
      overflow: hidden;

      .progress-cards-holder {
        display: flex;
        margin-top: 30px;
        align-items: stretch;

        .progress-card {
          margin-right: $card-margin-right;
          width: $card-width;
          flex-shrink: 0;
          background-color: $color-light;
          border: 1px solid $border-color-primary;
          padding: 35px 25px;
          border-radius: 8px;

          &:last-child { margin-right: 0; }

          .snack-bar {
            width: fit-content;
            padding: 12px 24px;
            min-height: unset;
          }

        }
      }

      .progress-shadow-right {
        position: absolute;
        top: 0;
        right: 0;
        width: $card-width;
        height: 100%;
        background: $color-light;
        background: linear-gradient(90deg, rgba($color-light, 0) 0%, $color-light 100%);
      }

      .progress-slider {
        transition: all .4s ease;
        width: ($cards-count * $card-width) + (($cards-count - 1) * $card-margin-right);
        min-width: $cards-count * $card-width + (($cards-count - 1) * $card-margin-right);
      }

      .progress-bar {
        left: $card-width / 2;
        height: 2px;
        width: (($cards-count - 1) * $card-width) + (($cards-count - 1) * $card-margin-right);
        min-width: (($cards-count - 1) * $card-width) + (($cards-count - 1) * $card-margin-right);
        background-image: linear-gradient(to right, $color-gray 50%, rgba($color-gray, 0) 0%);
        background-position: bottom;
        background-size: 15px 1px;
        background-repeat: repeat-x;
        margin: #{ $progress-circle-size / 2} 0;

        .progress-circle {
          position: absolute;
          width: $progress-circle-size;
          height: $progress-circle-size;
          border-radius: 50%;
          background-color: $color-light;
          border: 1px solid $color-gray;
          @include f-center();
          font-size: 18px;
          top: 0;
          transform: translate(-50%, -50%);

          &:nth-child(1) { left: 0; }

          @for $i from 1 through $cards-count - 1 {
            &:nth-child(#{$i + 1}) {
              $margin-right-diff: $card-margin-right;
              left: ($card-width * $i) + ($margin-right-diff * $i);
            }
          }
        }
      }
    }
  }

  @keyframes rotation{
    from { transform: rotate(0deg); }
    to{ transform: rotate(360deg); }
  }
</style>
